import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-EYS52NKLPW";

export default function GAListener() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;

    // Wait two animation frames so react-helmet-async has committed the
    // destination page's <title> before we read document.title. Without this
    // delay, the first paint fires page_view with the *previous* page title.
    let raf1 = requestAnimationFrame(() => {
      let raf2 = requestAnimationFrame(() => {
        window.gtag("event", "page_view", {
          page_path: pathname + search,
          page_location: window.location.href,
          page_title: document.title,
          send_to: GA_ID,
        });
      });
      // eslint-disable-next-line no-unused-vars
      raf1 = raf2; // keep lint quiet; both frames are actually needed
    });

    return () => cancelAnimationFrame(raf1);
  }, [pathname, search]);

  return null;
}
